import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// icons
import { ReactComponent as Search } from "assets/icons/svg/Search.svg";
import { SvgCross } from "assets/icons/js/SvgCross";
import { ReactComponent as LocationBig } from "assets/icons/svg/location.svg";
import { SvgNavigationArrow } from "assets/icons/js/SvgNavigationArrow";
import { SvgLocation } from "assets/icons/js/SvgLocation";

// context
import { SearchBarDataInterface } from "context/SearchBarData";
import { SearchPageDataInterface } from "context/SearchPageData";

// helpers
import {
	collectionUrl,
	searchUrlMobile,
	searchUrlMobileBar,
} from "helpers/url";

// style
import "./style.scss";
import { useSearchQuery } from "customHooks/useQuery";

export const LocationPopup = ({ setColletionLocationPopup }: any) => {
	const [search, setSearch] = useState("");
	const [selectSearch, setSelectSearch] = useState("");

	// @ts-ignore
	const { searchBar, setSearchQuery } = useContext(SearchBarDataInterface);

	// @ts-ignore
	const { setShowLocationPopup, setLocation } = useContext(
		SearchPageDataInterface,
	);

	const { pathname } = useLocation();
	const query = useSearchQuery();

	const { data } = searchBar;

	const newData = data?.data?.data;

	const navigate = useNavigate();

	const newArray = newData && Object?.values(newData).slice(0, 7);

	useEffect(() => {
		if (search === "") {
			setSelectSearch("");
		}
	}, [search]);

	const handleSearch = () => {
		if (pathname === "/search") {
			// @ts-ignore
			window.location.href = searchUrlMobileBar(query, "/search");
		}

		if (pathname.split("/")[1] === "villas") {
			// @ts-ignore
			window.location.href = searchUrlMobileBar(query, "villas");
		}
	};

	return (
		<div className="search__body-container">
			<div className="search__body-header">
				<SvgNavigationArrow
					onClick={() => {
						if (pathname === "/search" || pathname.split("/")[1] === "villas") {
							setShowLocationPopup(false);
						} else {
							setColletionLocationPopup(false);
						}
					}}
				/>
			</div>
			{!selectSearch && (
				<div className="search__input-box">
					<input
						id="search"
						autoFocus
						placeholder="Search for city, homes..."
						value={search}
						onChange={(e) => {
							setSearch(e.target.value);
							setSearchQuery(e.target.value);
						}}
					/>
					{search ? (
						<SvgCross
							onClick={() => {
								setSearch("");
								setSelectSearch("");
							}}
						/>
					) : (
						<Search />
					)}
				</div>
			)}{" "}
			<button className="search_anywhere" onClick={() => handleSearch()}>
				<span>
					<SvgLocation />
				</span>
				Anywhere
			</button>
			<div className="search__show-wrapper">
				{searchBar.isSuccess &&
					newArray &&
					newArray.length > 0 &&
					newArray?.map((search: any) => {
						return (
							<div
								className="home__suggest-wrapper"
								onClick={(e) => {
									if (!search.id) {
										if (
											pathname === "/search" ||
											pathname.split("/")[1] === "villas"
										) {
											setSearch(search.title);
											setSearchQuery(search.title);
											setShowLocationPopup(false);
											setLocation({
												latitude: search.latitude,
												longitude: search.longitude,
											});
										} else {
											setColletionLocationPopup(false);
											navigate(collectionUrl(search, pathname, query));
										}
										if (pathname === "/search") {
											// @ts-ignore
											navigate(searchUrlMobile(search, query, "/search"));
										} else if (pathname.split("/")[1] === "villas") {
											// @ts-ignore
											navigate(searchUrlMobile(search, query, "villas"));
										}
									}
									if (search.id) {
										navigate(`/view/${search.id}`);
									}
								}}
							>
								{search.image_id ? (
									<div className="home-suggest-img">
										<img
											src={`https://ik.imagekit.io/5tgxhsqev/saffronstays-media/tr:q-40/image/upload/${search?.image_id}`}
											alt="#"
										/>
									</div>
								) : (
									<LocationBig />
								)}
								<div className="home__suggest-details">
									<span>
										<h4>{search.title}</h4>
										<h5>{search.type}</h5>
									</span>
									<h5>{search.subtitle}</h5>
								</div>
							</div>
						);
					})}
			</div>
		</div>
	);
};
